module.exports = __webpack_public_path__ + "static/img/休眠.b679945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/小轿车/休眠.png
// module id = 5yD4
// module chunks = 76